import React, { useState, useEffect } from 'react';
import { object, string, number, array } from 'yup';
import { navigate } from 'gatsby';
import _ from 'lodash';
import { Formik } from 'formik';
import ToggleSelect from '../../../../../common/components/ToggleSelect/ToggleSelect';
import individual_icon from '../../../../../images/icons/UserKycIcons/individual_icon.svg';
import company_icon from '../../../../../images/icons/company_icon.svg';
import CompanyDetails from '../../../../Income/SENP/CompanyDetails';
import { getSelpEmployeedDetails } from '../../../../../common/constants/api';
import { getApplicantionInfo } from '../../../../../common/utils/applicantionInfo';
import PopUp from '../../../../../common/components/PopUp/PopUp';
import { staticData } from 'gatsby-env-variables';
const validationSchema = object().shape({
  applyLoanAs: string().required('Required'),
  companyType: string().when('applyLoanAs', {
    is: 'Company',
    then: string().required('required')
  }),
  industry_list: object().shape({
    value: string().when('applyLoanAs', {
      is: 'Company',
      then: string().required('Required')
    })
  }),
  cin: string()
    .when('companyType', {
      is: 'Limited',
      then: string()
        .required('Required')
        .min(21, 'Must be 21 digits')
        .max(21, 'Must be 21 digits')
        .matches(
          /^([L|U]{1})([0-9]{5})([A-Za-z]{2})([0-9]{4})([A-Za-z]{3})([0-9]{6})$/,
          'Not a Valid CIN'
        ),
      otherwise: string().when('companyType', {
        is: 'Private Limited',
        then: string()
          .required('Required')
          .min(21, 'Must be 21 digits')
          .max(21, 'Must be 21 digits')
          .matches(
            /^([L|U]{1})([0-9]{5})([A-Za-z]{2})([0-9]{4})([A-Za-z]{3})([0-9]{6})$/,
            'Not a Valid CIN'
          )
      })
    })
    .nullable(),
  nature_of_business: object().shape({
    value: string().when('applyLoanAs', {
      is: 'Company',
      then: string().required('Required')
    })
  }),
  llpin: string()
    .when('companyType', {
      is: 'LLP',
      then: string().required('required')
    })
    .nullable(),
  company_pan: string()
    .when('companyType', {
      is: val => val == 'LLP' || val == 'Private Limited' || val == 'Limited',
      then: string().required('required')
    })
    .nullable(),
  company_name: string().when('companyType', {
    is: 'Proprietorship',
    then: string().required('required'),
    otherwise: string().nullable()
  })
});

const LAPCompanySelection = () => {
  const [disable, setDisable] = useState(false);
  const [getValues, setGetValues] = useState('');
  const [show, setShow] = useState(false);
  return (
    <Formik
      initialValues={{
        applyLoanAs: '',
        isShowFileds: '',
        companyType: '',
        company_name: '',
        sub_industry: { value: '', label: 'Choose Sub Industry' },
        industry_list: { value: '', label: 'Choose Industry"' },
        nature_of_business: { value: '', label: 'Nature Of Business' },
        cin: '',
        llpin: '',
        shouldDisabled: false
      }}
      validationSchema={validationSchema}
      onSubmit={(values, { setSubmitting, resetForm }) => {
        setSubmitting(true);
        navigate(staticData?.userKyc || 'app/UserKyc');
      }}
    >
      {propsFromFormik => {
        const {
          values,
          errors,
          setFieldValue,
          handleReset,
          handleSubmit,
          validateForm
        } = propsFromFormik;

        const styledCompanyDetails = () => (
          <div className="mt-20">
            <CompanyDetails setDisable={setDisable} lap getValues={getValues} />
          </div>
        );
        useEffect(() => {
          setShow(true);
          getSelpEmployeedDetails(
            getApplicantionInfo().leadId,
            getApplicantionInfo().leadApplicantId
          )
            .then(res => {
              setDisable(true);
              setGetValues(res);
              setFieldValue('shouldDisabled', true);
              setDisable(true);
              setFieldValue('isShowFileds', true);
              setFieldValue('companyType', _.get(res, 'companyType', false));
              setFieldValue('auto_complete_cin', _.get(res, 'companyName', ''));
              setFieldValue('company_name', _.get(res, 'companyName', ''));

              if (values.companyType == 'LLP') {
                setFieldValue('cin', _.get(res, 'cin', ''));
              } else {
                setFieldValue('llpin', _.get(res, 'cin', ''));
              }

              setFieldValue('cin', _.get(res, 'cin', ''));
              setFieldValue('nature_of_business', {
                value: _.get(res, 'natureOfBusiness.id', false),
                label: _.get(res, 'natureOfBusiness.name', 'Nature Of Business')
              });
              setFieldValue('industry_list', {
                value: _.get(res, 'industry.id', false),
                label: _.get(res, 'industry.name', 'Choose Industry')
              });
              setFieldValue('sub_industry', {
                value: _.get(res, 'subIndustry.id', false),
                label: _.get(res, 'subIndustry.name', 'Choose Sub Industry')
              });
              setFieldValue('company_pan', _.get(res, 'companyPan', false));
              setFieldValue('gstNumber', _.get(res, 'gstNumber', false));
              setShow(false);
            })
            .catch(err => {
              setDisable(false);
              setShow(false);
            });
        }, []);

        useEffect(() => {
          if (disable) {
            setFieldValue('applyLoanAs', 'Company');
          } else {
            setFieldValue('applyLoanAs', '');
          }
        }, [disable]);

        useEffect(() => {
          validateForm();
          return () => {};
        }, []);

        return (
          <React.Fragment>
            {show && (
              <PopUp
                type="loading"
                text="Fetching Data . ."
                setShow={setShow}
                show={show}
              />
            )}
            <div className="px-5 md:px-2">
              <p className="pt-2 text-black-850 text-base font-medium font-roboto">
                Applying Loan as
              </p>
              <div className="flex my-4">
                <ToggleSelect
                  disabled={disable}
                  img={individual_icon}
                  name="applyLoanAs"
                  value="Individual"
                  checked={values.applyLoanAs === 'Individual'}
                  onChange={async e => {
                    const hold = e;
                    handleReset();
                    await setFieldValue('applyLoanAs', hold.target.value);
                  }}
                  addClasses="cursor-pointer hover:bg-green-100 hover:border-green-1000"
                  containerStyle={{
                    width: '7.5rem',
                    height: '100px',
                    marginRight: '20px'
                  }}
                  nameDisplay="Individual"
                  namingStyle={{
                    paddingTop: '40px',
                    color:
                      values.applyLoanAs === 'Individual'
                        ? '#00ACB8'
                        : '#7B8C9B'
                  }}
                />
                <ToggleSelect
                  disabled={disable}
                  img={company_icon}
                  name="applyLoanAs"
                  value="Company"
                  checked={values.applyLoanAs === 'Company'}
                  onChange={e => {
                    setFieldValue('applyLoanAs', e.target.value);
                  }}
                  addClasses="cursor-pointer hover:bg-green-100 hover:border-green-1000"
                  containerStyle={{
                    width: '7.5rem',
                    height: '100px'
                  }}
                  nameDisplay="Company"
                  namingStyle={{
                    paddingTop: '40px',
                    color:
                      values.applyLoanAs === 'Company' ? '#00ACB8' : '#7B8C9B'
                  }}
                />
              </div>
              {values.applyLoanAs === 'Company' && styledCompanyDetails()}

              {(values.applyLoanAs === 'Individual' ||
                values.applyLoanAs === '') && (
                <div className="mt-12">
                  <button
                    type="submit"
                    onClick={handleSubmit}
                    disabled={!_.isEmpty(errors)}
                    className="submitButton font-roboto text-white text-base w-48 "
                  >
                    NEXT
                  </button>
                </div>
              )}
            </div>
          </React.Fragment>
        );
      }}
    </Formik>
  );
};

export default LAPCompanySelection;
